import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

import { stationStatus } from '../constants';
import pagination from './pagination';

const keyword = (state = "", action) => {
  switch(action.type){
    case actionTypes.CHANGE_SEARCH_KEYWORD:
      return action.keyword;
    default:
      return state;
  }
}

const stationName = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_STATION_NAME:
      return action.stationName;
    default:
      return state;
  }
}

const status = (state = stationStatus.active, action) => {
  switch(action.type){
    case actionTypes.SET_STATUS:
      return action.status;
    default:
      return state;
  }
}

export default combineReducers({
  keyword,
  stationName,
  pagination,
  status
});

const getCurrentState = state => state.stations.stationsSearchForm;

export const getKeyword = state => getCurrentState(state).keyword

export const getStationName = state => getCurrentState(state).stationName

export const getPagination = state => getCurrentState(state).pagination

export const getStatus = state => getCurrentState(state).status